import { Component, OnInit, Optional, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { AddMemberByDisciplinaryPanelComponent } from '../add-member-by-disciplinary-panel/add-member-by-disciplinary-panel.component';
import { AddMemberByInvitationComponent } from '../add-member-by-invitation/add-member-by-invitation.component';
import { AddMemberByUserProfileComponent } from '../add-member-by-user-profile/add-member-by-user-profile.component';

@Component({
  selector: 'kt-add-member-types',
  templateUrl: './add-member-types.component.html',
  styleUrls: ['./add-member-types.component.scss']
})
export class AddMemberTypesComponent implements OnInit {
  public memberTypeCategories: Array<any> = []
  public icon: string = '';

  constructor(
    private dialogRef: MatDialogRef<AddMemberTypesComponent>,
    public matDialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
  }



  ngOnInit() {
    this.memberTypeCategories = this.getAddMemberTypes()
    this.memberTypeCategories.forEach(category => {
      category.icon = this.getIcon(category.codeId);
    });
  }

  public onButtonClick(button?) {
    this.dialogRef.close(button);
  }

  private getAddMemberTypes() {
    let initialArray = [{
      codeId: HEC_CONSTANTS.Member_Types['BY_USER_PROFILE'].codeId,
      codeValue: HEC_CONSTANTS.Member_Types['BY_USER_PROFILE'].codeValue

    },
    {
      codeId: HEC_CONSTANTS.Member_Types['BY_INVITATION'].codeId,
      codeValue: HEC_CONSTANTS.Member_Types['BY_INVITATION'].codeValue

    }
    ]
    if (!this.data.hideDisciplinaryModal) {
      initialArray.push({
        codeId: HEC_CONSTANTS.Member_Types['BY_DISCIPLINARY_PANEL'].codeId,
        codeValue: HEC_CONSTANTS.Member_Types['BY_DISCIPLINARY_PANEL'].codeValue
      })
    }

    return initialArray;

  }
 
  private getIcon(typeCode): string {
    switch (typeCode) {
      case HEC_CONSTANTS.Member_Types['BY_DISCIPLINARY_PANEL'].codeId:
        this.icon = '<i class="fas fa-columns"></i>'
        break;
      case HEC_CONSTANTS.Member_Types['BY_USER_PROFILE'].codeId:
        this.icon = '<i class="fas fa-search"></i>'
        break;
      case HEC_CONSTANTS.Member_Types['BY_INVITATION'].codeId:
        this.icon = '<i class="fas fa-user-plus"></i>'
        break;

      default:
        this.icon = '<span class="icon-sedan-car-model"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>'
    }
    return this.icon
  }


  public chooseCategory(member): void {
    localStorage.removeItem('MEMBER_TYPE_CODE')
    localStorage.setItem("MEMBER_TYPE_CODE", member.codeId);
    this.navigationUsingMemberType(member.codeId)
  }

  private navigationUsingMemberType(memberCode): void {
    switch (memberCode) {
      case HEC_CONSTANTS.Member_Types['BY_DISCIPLINARY_PANEL'].codeId:
        this.addMemberByDisciplinaryPanel()
        break;

      case HEC_CONSTANTS.Member_Types['BY_USER_PROFILE'].codeId:
        this.addMemberByUserProfile()
        break;

      case HEC_CONSTANTS.Member_Types['BY_INVITATION'].codeId:
        this.addMemberByInvitation()
        break;

      default:
    }
  }

  private addMemberByDisciplinaryPanel(): void {
    const dialogRef = this.matDialog.open(AddMemberByDisciplinaryPanelComponent, {
      width: '80vw',
      height: '80vh',
      panelClass: 'custom-scrutiny-popup',
      autoFocus: false,
      data: {
        grantId: this.data.grantId ? this.data.grantId : null, panelData: this.data.panelData ? this.data.panelData : null,
        batchId: this.data.batchId ? this.data.batchId : null,
        hideCategoryAndPanels: this.data.hideCategoryAndPanels ? this.data.hideCategoryAndPanels : null,
        pageState: this.data.pageState
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(result)
      }
    });

  }

  private addMemberByUserProfile(): void {
    const dialogRef = this.matDialog.open(AddMemberByUserProfileComponent, {
      width: '80vw',
      height: '80vh',
      panelClass: 'custom-scrutiny-popup',
      autoFocus: false,
      data: {
        grantId: this.data.grantId ? this.data.grantId : null,
        panelData: this.data.panelData ? this.data.panelData : null,
        batchId: this.data.batchId ? this.data.batchId : null,
        hideCategoryAndPanels: this.data.hideCategoryAndPanels ? this.data.hideCategoryAndPanels : null,
        pageState: this.data.pageState
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(result)

      }
    });

  }

  private addMemberByInvitation(): void {
    const dialogRef = this.matDialog.open(AddMemberByInvitationComponent, {
      width: '80vw',
      height: '80vh',
      panelClass: 'custom-scrutiny-popup',
      autoFocus: false,
      data: {
        grantId: this.data.grantId ? this.data.grantId : null,
        panelData: this.data.panelData ? this.data.panelData : null,
        batchId: this.data.batchId ? this.data.batchId : null,
        hideCategoryAndPanels: this.data.hideCategoryAndPanels ? this.data.hideCategoryAndPanels : null,
        pageState: this.data.pageState
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(result)
      }
    });
  }

}
